import { useTranslation } from 'react-i18next';
import { letterHeadingParts, topicStandIn } from '@/lib/medcom/letterDisplay';
import { PAGE_TITLE } from '@/components/ui/pageChrome';

export function LetterTopic({
  topic,
  category,
}: {
  topic?: string | null;
  category?: string | null;
}) {
  const { t } = useTranslation();
  const categoryName = category?.trim()
    ? t(`communicate.category_${category}`, { defaultValue: category })
    : null;
  const shown = topicStandIn(topic, categoryName);
  if (!shown) return '—';
  if (!shown.standIn) return shown.text;
  return <span className="italic text-ds-muted">{shown.text}</span>;
}

export function LetterCategory({ category }: { category?: string | null }) {
  const { t } = useTranslation();
  const code = category?.trim();
  if (!code) return '—';
  return t(`communicate.category_${code}`, { defaultValue: code });
}

export function LetterTitle({
  category,
  topic,
  fallback,
}: {
  category?: string | null;
  topic?: string | null;
  fallback: string;
}) {
  const { t } = useTranslation();
  const categoryLabel = category?.trim()
    ? t(`communicate.category_${category}`, { defaultValue: category })
    : null;
  const parts = letterHeadingParts(categoryLabel, topic, fallback);
  return (
    <div>
      <h2 className={PAGE_TITLE}>{parts.title}</h2>
      {parts.subjectBelow ? (
        <p className="mt-1 text-base font-medium text-ds-text">
          {parts.subjectBelow}
        </p>
      ) : null}
    </div>
  );
}

export function LetterCategorySubjectLines({
  category,
  topic,
}: {
  category?: string | null;
  topic?: string | null;
}) {
  const { t } = useTranslation();
  const categoryLabel = category?.trim()
    ? t(`communicate.category_${category}`, { defaultValue: category })
    : null;
  const subject = topic?.trim() || null;
  if (!categoryLabel && !subject) return null;
  return (
    <div className="col-span-2 space-y-2">
      {categoryLabel ? (
        <div>
          <span className="font-normal text-ds-muted">{t('communicate.col_category')}:</span>
          <span className="ml-2">{categoryLabel}</span>
        </div>
      ) : null}
      {subject ? (
        <div>
          <span className="font-normal text-ds-muted">{t('communicate.col_topic')}:</span>
          <span className="ml-2">{subject}</span>
        </div>
      ) : null}
    </div>
  );
}
